<template>
  <div class="order-deposit-wrap">
    <el-form
      ref="searchForm"
      label-position="right"
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-bottom: 10px"
    >
      <el-form-item label="定金单号">
        <el-input
          v-model="searchForm.depositOrder"
          placeholder="请输入定金单号"
        />
      </el-form-item>

      <el-form-item label="锐锢编码">
        <el-input v-model="searchForm.skuCode" placeholder="请输入商品编码" />
      </el-form-item>

      <el-form-item label="下单日期">
        <el-date-picker
          v-model="searchForm.date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
        <el-button
          type="primary"
          size="small"
          style="
            background: #fff;
            color: #ff6224;
            border-color: #ccc;
            color: #666;
          "
          @click="resetForm"
          >重置
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="onExport()"
          :loading="exportLoading"
        >
          导出
        </el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <el-tabs type="card" v-model="activeKey" @tab-click="handleTabChange">
        <el-tab-pane :label="`全部（${total.all || 0}）`" name="all">
        </el-tab-pane>
        <el-tab-pane :label="`已付定金（${total['20'] || 0}）`" name="20">
        </el-tab-pane>
        <el-tab-pane :label="`已取消（${total['-1'] || 0}）`" name="-1">
        </el-tab-pane>
        <el-tab-pane :label="`已付尾款（${total['40'] || 0}）`" name="40">
        </el-tab-pane>
      </el-tabs>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%; text-align: center"
          size="mini"
          :row-key="row => row.depositOrder"
          show-summary
          :summary-method="getSummaries"
        >
          >
          <el-table-column prop="createdAt" label="下单日期" width="180" />
          <el-table-column prop="depositOrder" label="定金单号" />
          <el-table-column prop="orderNumber" label="子订单号" />
          <el-table-column prop="skuCode" label="锐锢编码" width="120" />
          <el-table-column
            prop="skuName"
            label="商品名称"
            :show-overflow-tooltip="true"
          />
          <el-table-column prop="price" label="商品单价" />
          <el-table-column prop="qty" label="下单数量" />
          <el-table-column prop="totalPrice" label="订单金额" />
          <el-table-column prop="orderStatue" label="订单状态" width="120">
            <template slot-scope="scope">{{
              scope.row.orderStatue | statusFilter
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.page"
        :page-sizes="[10, 20, 50, 100, 200, 500]"
        :page-size="pagination.page_size"
        layout="total,sizes, prev, pager, next,jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// -1取消&关闭，20已付定金，40已付尾款
import { queryList, getTotalNum, exportData } from "@/models/orderDeposit";
import moment from "moment";
export default {
  data() {
    return {
      activeKey: "all",
      pagination: {
        page: 1,
        page_size: 10,
        total: 0
      },
      searchForm: {
        depositOrder: "",
        skuCode: "",
        date: ""
      },
      tableData: [], // 表格数据
      loading: false,
      exportLoading: false,
      total: { all: 0, "20": 0, "-1": 0, "40": 0 }
    };
  },
  created() {
    this.getList(this.searchForm); //获取列表
    this.getTotal();
  },

  filters: {
    statusFilter(val) {
      let text = "";
      switch (Number(val)) {
        case -1:
          text = "已取消";
          break;
        case 20:
          text = "已付定金";
          break;
        case 40:
          text = "已付尾款";
          break;
        default:
          break;
      }
      return text;
    }
  },
  methods: {
    //获取数据列表
    getList(param) {
      const searchParams = param || this.searchForm;
      const params = {
        ...searchParams,
        shopId: localStorage.getItem("shop_id"),
        orderStatue: this.activeKey === "all" ? "" : this.activeKey,
        page: this.pagination.page || 1,
        pageSize: this.pagination.page_size || 10
      };
      if (params.date && params.date.length == 2) {
        params.startDate = moment(params.date[0]).format("YYYY-MM-DD 00:00:00");
        params.endDate = moment(params.date[1]).format("YYYY-MM-DD 23:59:59");
        delete params.date;
      }

      this.loading = true;
      queryList(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.data || []; // 获取数据
          this.pagination.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 数据汇总
    getTotal() {
      getTotalNum({
        shopId: localStorage.getItem("shop_id")
      }).then(res => {
        let all = 0;
        res &&
          res.map(item => {
            this.total[item.orderStatus] = item.qty;
            all += item.qty;
          });
        this.total.all = all;
      });
    },
    // 重置
    resetForm() {
      const params = {
        depositOrder: "",
        skuCode: "",
        date: ""
      };
      this.searchForm = params;
      this.pagination = {
        ...this.pagination,
        page: 1,
        page_size: 10
      };
      this.getList({ ...params });
    },

    // 改变pagesize
    handleSizeChange(value) {
      this.pagination.page_size = value;
      this.$nextTick(() => {
        this.getList({ ...this.searchForm });
      });
    },
    // 改变page
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.$nextTick(() => {
        this.getList({ ...this.searchForm });
      });
    },
    // 导出
    async onExport() {
      const { depositOrder, skuCode, date } = this.searchForm;
      const params = {
        depositOrder,
        skuCode,
        shopId: localStorage.getItem("shop_id"),
        orderStatue: this.activeKey === "all" ? "" : this.activeKey
      };

      if (date && date.length == 2) {
        params.startDate = moment(date[0]).format("YYYY-MM-DD 00:00:00");
        params.endDate = moment(date[1]).format("YYYY-MM-DD 23:59:59");
      }
      //   this.exportLoading = true;
      await exportData(params);
      //   this.exportLoading = false;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 6 || index === 7) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                const res = prev * 100 + curr * 100;
                return res / 100;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        }
      });

      return sums;
    },
    // tab切换
    handleTabChange(e) {
      const currentKey = e.$options.propsData.name;
      this.activeKey = currentKey;
      this.pagination = { ...this.pagination, page: 1, page_size: 10 };
      this.$nextTick(() => {
        this.getList({
          ...this.searchForm,
          orderStatue: currentKey === "all" ? "" : currentKey
        });
      });
    }
  }
};
</script>
<style lang="scss">
.order-deposit-wrap {
  .table-wrap {
    border-top: 1px solid #eee;
    padding-top: 16px;
    margin-top: 16px;
  }

  .opt-btn {
    cursor: pointer;
    color: #ff6224;
  }

  .el-tabs__item.is-active {
    color: #ff4d4f !important;
    border-bottom: 2px solid #fff;
  }
  .el-tabs__item:hover {
    color: #ff4d4f !important;
  }
}
.order-deposit-form .el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderDeposit.vue